import React from "react";
import PropTypes from "prop-types";
import Avatar from "../../common/Avatar";
import HeaderComponent from "./header.style";
import { DEFAULT_LANDING_ROUTE } from "../../../helpers/constant";
import CustomLink from "../../common/CustomLink";
import Typography from "../../common/Typography/Typography";

export default function Header({ logo, logoTag }) {
  const { Wrapper, Container } = HeaderComponent;

  return (
    <Wrapper>
      <Container>
        <div className="flex-center-center">
          <CustomLink to={DEFAULT_LANDING_ROUTE()}>
            <Avatar hoverable size="sm" src={logo} />
          </CustomLink>
          <Typography color="white" variant="h5">
            {logoTag}
          </Typography>
        </div>
      </Container>
    </Wrapper>
  );
}

Header.propTypes = {
  /**
   * Application logo can be passed
   */
  logo: PropTypes.string,
  /**
   * Logged in user profile picture for avatar
   */
  profilePicture: PropTypes.string,
  /**
   * To show only logo on navbar when screen is not in login/signup screen
   */
  protectedRoute: PropTypes.bool,

  logoTag: PropTypes.string,
};

Header.defaultProps = {
  logo: "",
  profilePicture: "",
  protectedRoute: false,
  logoTag: "Service Order Tracker",
};
